import React from "react";
import MenuLayout from "../../components/MenuLayout/MenuLayout";

const NotFound = () => {

    return (
        <MenuLayout currentPage="Página Inexistente">
        </MenuLayout>
    );
}


export default NotFound;